import { commentItems } from '@/mocks/home';

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 mx-auto max-w-7xl">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-sm font-medium text-accent-600 mb-2">口碑见证</p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">用户心声</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-lg mx-auto">来自真实用户的使用评价，听听他们怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    width="40"
                    height="40"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.date}</div>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: item.rating }).map((_, i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-sm text-primary-500"></i>
                    </div>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-3">
                {item.content}
              </p>
              <div className="text-xs text-foreground-400">
                {item.source}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}